// Keep in sync with app/lib/enums/score_gap_report_type.py
const ScoreGapReportType = Object.freeze({
  INTERNAL: 'INTERNAL',
  CUSTOMER: 'CUSTOMER',
});

const SCORE_GAP_REPORT_TYPE_LABELS = Object.freeze({
  [ScoreGapReportType.INTERNAL]: 'Internal (FSA team)',
  [ScoreGapReportType.CUSTOMER]: 'Customer-facing',
});

export default ScoreGapReportType;
export { SCORE_GAP_REPORT_TYPE_LABELS };
